<template>
  <div class="container-fluid px-4 py-4 legal-page">

    <!-- Header estilo panel -->
    <div class="legal-header mb-4">
      <button class="btn-volver mb-3" @click="$router.back()">
        <i class="fas fa-arrow-left"></i> Volver
      </button>
      <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">
        <div>
          <h4 class="mb-1">Aviso Legal</h4>
          <p class="mb-0 text-muted">
            Información del titular del sitio, condiciones de uso y marco legal aplicable (LSSI-CE).
          </p>
        </div>

        <div class="legal-meta">
          <div class="meta-title">Última actualización</div>
          <div class="meta-value">{{ lastUpdate }}</div>
        </div>
      </div>
    </div>

    <!-- Card principal -->
    <div class="card legal-card">
      <div class="card-body">

        <div class="soft-note mb-4">
          <b>Resumen:</b> este documento recoge la información del titular del sitio web y las condiciones de uso.
          Si tienes dudas, puedes escribirnos a <b>soporte@payoned.com</b>.
        </div>

        <p class="text-muted mb-3">
          En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002 (LSSI-CE),
          se informa que el presente sitio web es titularidad de:
        </p>

        <!-- Bloque superior (solo títulos: Titular / NIF / Domicilio) -->
        <div class="legal-mini mb-4">
          <div class="mini-grid">
            <div class="mini-item">
              <div class="mini-label">Titular</div>
              <div class="mini-value">XESPORT GALICIA S.L.</div>
            </div>

            <div class="mini-item">
              <div class="mini-label">NIF</div>
              <div class="mini-value">B27777887</div>
            </div>

            <div class="mini-item">
              <div class="mini-label">Domicilio</div>
              <div class="mini-value">CC/ LOPEZ mora n71 5A 36211 Vigo (Pontevedra), Galicia, España.</div>
            </div>
          </div>

          <hr class="mini-sep" />

          <!-- Extra (más info, pero separado) -->
          <div class="mini-extra">
            <p class="mb-2">
              <b>Email de contacto:</b> soporte@payoned.com
              <span class="mx-2">•</span>
              <b>Servicio:</b> Quanty
            </p>
            <p class="mb-0 text-muted small">
              Para información detallada sobre tratamiento de datos personales, consulta la
              <router-link to="/politica-privacidad">Política de Privacidad</router-link>.
              Para información sobre cookies y preferencias, consulta la
              <router-link to="/politica-cookies">Política de Cookies</router-link>.
            </p>
          </div>
        </div>

        <h5 class="mt-4">1. Objeto</h5>
        <p>
          El acceso a este sitio web es gratuito. A través de este sitio se facilita información sobre los servicios
          ofrecidos por la entidad titular.
        </p>

        <h5 class="mt-4">2. Condiciones de uso</h5>
        <p>
          El usuario se compromete a hacer un uso adecuado de los contenidos y servicios y, con carácter enunciativo,
          a no emplearlos para:
        </p>
        <ul class="mb-4">
          <li>Realizar actividades ilícitas o contrarias a la buena fe y al orden público.</li>
          <li>Provocar daños en los sistemas del titular o de terceros, o introducir/propagar malware.</li>
          <li>Intentar acceder sin autorización a áreas restringidas, cuentas o recursos de terceros.</li>
        </ul>
        <p>
          El acceso y uso de este sitio web está reservado a personas mayores de 18 años.
        </p>

        <h5 class="mt-4">3. Propiedad intelectual e industrial</h5>
        <p>
          Todos los contenidos de este sitio web (textos, imágenes, diseños, código, logos, marcas, etc.)
          son propiedad del titular o dispone de los derechos necesarios para su uso.
          Queda prohibida su reproducción, distribución o transformación, total o parcial, sin autorización expresa.
        </p>

        <h5 class="mt-4">4. Responsabilidad</h5>
        <p>
          El titular no se hace responsable del mal uso que se realice de los contenidos del sitio web, siendo
          exclusiva responsabilidad de la persona que accede o utiliza dichos contenidos.
        </p>
        <p class="mb-4">
          Asimismo, el titular no garantiza la disponibilidad continua del sitio ni la ausencia de errores técnicos,
          aunque adoptará medidas razonables para mantener el correcto funcionamiento.
        </p>

        <h5 class="mt-4">5. Enlaces a terceros</h5>
        <p class="mb-4">
          Este sitio puede incluir enlaces a páginas de terceros. El titular no asume responsabilidad por el contenido,
          políticas o prácticas de dichos sitios externos. Se recomienda revisar sus condiciones y políticas.
        </p>

        <h5 class="mt-4">6. Protección de datos</h5>
        <p class="mb-4">
          El tratamiento de datos personales, en su caso, se rige por lo indicado en la
          <router-link to="/politica-privacidad">Política de Privacidad</router-link>.
        </p>

        <h5 class="mt-4">7. Zona horaria aplicable</h5>
        <p class="mb-4">
          A efectos de todos los cobros, suscripciones, renovaciones, cancelaciones, periodos de prueba y
          cualquier otra operación con efecto temporal, la hora oficial que rige es la de
          <b>España peninsular y Baleares (Europe/Madrid)</b>, correspondiente a:
        </p>
        <ul class="mb-4">
          <li><b>UTC+1</b> durante el horario de invierno (último domingo de octubre — último domingo de marzo).</li>
          <li><b>UTC+2 (CEST)</b> durante el horario de verano (último domingo de marzo — último domingo de octubre).</li>
        </ul>
        <p class="mb-4">
          Toda referencia horaria que aparezca en facturas, avisos, confirmaciones o notificaciones del servicio
          se expresa en esta zona horaria, con independencia de la ubicación geográfica del usuario.
        </p>

        <h5 class="mt-4">8. Legislación aplicable</h5>
        <p class="mb-0">
          Cualquier controversia se regirá por la legislación española y se someterá a los Juzgados y Tribunales
          de Vigo, salvo que la normativa aplicable disponga otra cosa.
        </p>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "AvisoLegal",
  beforeMount() {
    this.$store.commit('setShowSidenav', false);
    this.$store.commit('setShowNavbar', true);
    this.$store.commit('setShowFooter', true);
  },
  data() {
    return {
      // Puedes mover esto a .env si quieres: VUE_APP_LEGAL_LAST_UPDATE
      lastUpdate: process.env.VUE_APP_LEGAL_LAST_UPDATE || "28/10/2026",
    };
  },
};
</script>

<style scoped>
.legal-card{
  border-radius: 14px;
  box-shadow: 0 10px 30px rgba(0,0,0,.06);
  border: 1px solid var(--q-border);
}

.legal-header{
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 14px;
  padding: 16px 18px;
}

.legal-meta{
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 10px 12px;
  min-width: 220px;
}

.meta-title{ font-size: .75rem; opacity: .75; }
.meta-value{ font-weight: 800; }

.soft-note{
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--q-hover);
  border: 1px solid var(--q-border);
}

/* mini ficha titular */
.legal-mini{
  border-radius: 14px;
  padding: 14px 14px;
  border: 1px solid var(--q-border);
  background: var(--q-card-alt);
}

.mini-grid{
  display:grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.mini-item{
  background: var(--q-card);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 10px 12px;
}

.mini-label{
  font-size: .75rem;
  opacity: .7;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .03em;
}

.mini-value{
  font-weight: 800;
  margin-top: 2px;
  word-break: break-word;
}

.mini-sep{
  margin: 12px 0;
  border: 0;
  border-top: 1px solid var(--q-border);
}

.mini-extra{
  padding: 0 2px;
}

@media (max-width: 992px){
  .mini-grid{ grid-template-columns: 1fr; }
}

.btn-volver {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--q-border-md);
  color: var(--q-muted);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: .85rem;
  cursor: pointer;
  transition: color .15s, border-color .15s;
}
.btn-volver:hover { color: var(--q-text); border-color: var(--q-gold); }
</style>
